export default __webpack_public_path__ + "static/media/Background 5_00034.172040a5.png";